import { render, staticRenderFns } from "./DocumentTemplatesSection.vue?vue&type=template&id=498149dd"
import script from "./DocumentTemplatesSection.vue?vue&type=script&lang=js"
export * from "./DocumentTemplatesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports